import { FloatingPortal } from "@floating-ui/react";
import { createContext, useContext } from "react";

export const FloatingPortalContext = createContext<{ root: HTMLElement | null }>({ root: null });
function useFloatingPortalContext() {
   return useContext(FloatingPortalContext);
}

export function MITFloatingPortal(props: { children: React.ReactNode }) {
   const { root } = useFloatingPortalContext();

   return (
      <FloatingPortal root={root}>
         {props.children}
      </FloatingPortal>
   )
}